import {useContext} from 'react'
import moment from 'moment'
import Moment from 'react-moment';

import Button from '../Atoms/Button'
import Loader from '../Loader/Loader'
import './SubmitScreen.sass'
import Lkw from '../../Images/image-lkw.jpg'
// import Edit from '../../Images/icon-edit.svg'
import Lieferstelle from '../Lieferstelle/Lieferstelle';
import { useState } from 'react';
import axios from 'axios';
import Modal from '../Modal/Modal';
import Radio from '../Atoms/Radio';
import { useSessionStorage } from '../Hooks/useSessionStorage';
import Input from '../Atoms/Input';

import { ProductContext } from '../Context/Context'
import Tracking from '../Functions/tracking';



const SubmitScreen = (props) => {

	// console.log(props.path)

	const {
		bestellung,
		setStep,
	} = useContext(ProductContext)


	const [consent, setConsent] = useState(false)
	const [privacyConsent, setPrivacyConsent] = useState(false)
	const [submissionError, setSubmissionError] = useState(false)
	const [isLoading, setIsLoading] = useState(false)
	const [kwk, setKwk] = useSessionStorage('no__kwk', false)
	const [gewinnspiel, setGewinnspiel] = useSessionStorage('no__gewinnspiel', false)
	const [error, setError] = useState(false)

	const contact = props.bestellung.contact
	const totals = props.bestellung.totals
	const wunschtermin = props.bestellung.wunschtermin

	const termin = wunschtermin.datum ? moment(wunschtermin.datum) : false

	const handleTextareaChange = (e) => { 
		props.handleChange(prev => ({
			...bestellung,
			comment: e.target.value.replace(/(<([^>]+)>)/gi, "").replace("'", "“")
		}))
	}

	const handleKwk = () => {
		setKwk(() => !kwk)
		setError(() => false)
		props.handleChange({
			...bestellung,
			contact: {
				...bestellung.contact,
				main: {
					...bestellung.contact.main,
					werberId: ""
				}
			}
		})
	}

	const handleKwkId = (e) => {
		
		props.handleChange({
			...props.bestellung,
			contact: {
				...props.bestellung.contact,
				main: {
					...props.bestellung.contact.main,
					werberId: e.target.value
				}
			}
		})
	}
	const handleKwkIdBlur = (e) => {		
		if (isNaN(e.target.value) || e.target.value.length < 5 || e.target.value.length > 6) {
			return setError('Bitte eine gültige Kundennummer angeben')		}
		setError(false)
	}

	const handleSubmit = () => { 

		const formData = new FormData()
		props.bestellung.totals.lieferfahrzeug = parseFloat(props.bestellung.totals.lieferfahrzeug)
		let data = JSON.stringify(props.bestellung)
		
		window.dataLayer = window.dataLayer || [];

		formData.append('bestellung', data)

		console.log(props.bestellung)


		setIsLoading(true)

		axios.post(`${props.path}/wp-content/plugins/nordoel-heizoelrechner/admin/handleSubmission.php`, formData)
			.then(res => {
				setSubmissionError(false)
				// console.log(res.data)

				window.dataLayer.push({
					'event': 'heizoelrechnerBestellung',
					'bestellung': props.bestellung
				})

				// sendTrackingEvent
				
				
				setIsLoading(false)
				Tracking.setPurchase(bestellung.totals.productName, bestellung.totals.productId, bestellung.liefermenge, bestellung.totals.allTotalNetto, bestellung.plz, bestellung.lieferfahrzeug[0], bestellung.schlauch[0], bestellung.contact.main.payment.method)
				props.next()
			})
			.catch(err => {
				console.log(err)
				setIsLoading(false)
				setSubmissionError(true)
			})
		
	}

	return (
		<div className="no__checkscreen">
			<div className="no__check-heading">
				<div className="no__checkheading-content">
					<h3 className="no__containerline">Gleich sind wir unterwegs zu Ihnen!</h3>
					<div className="no__flex-justify">
						<strong className="no__blue">Lieferübersicht</strong>
						{/* <EditButton click={() => props.setStep(1)}><img src={Edit} alt="Bearbeiten"/><span>Bearbeiten</span></EditButton> */}
					</div>
					<p>{totals.productName}</p>
					{
						termin && <p>Wunschtermin <Moment format='DD.MM.YYYY, HH:mm'>{termin}</Moment> Uhr</p>
					}
					<p>Schlauchlänge {props.bestellung.schlauch[0]}</p>
					<p>Lieferfahrzeug: {props.bestellung.lieferfahrzeug[0]}</p>
				</div>
				<div className="no__checkheading-image">
					<img src={Lkw} alt="Nordoel" />
				</div>
			</div>
			<div className="no__check-lieferstellen">

				<Lieferstelle
					number="1"
					plz={props.bestellung.plz}
					liefermenge={props.bestellung.liefermenge}
					contact={{
						company: contact.main.company,
						first: contact.main.first,
						last: contact.main.last,
						street: contact.main.street,
						street_number: contact.main.street_number,
						city: contact.main.city,
						email: contact.main.email,
						billing: contact.main.billing,
						birthday: contact.main.birthday,
						payment: {
							method: contact.main.payment.method,
							price: contact.main.payment.price
						},
					}}
				/>

				{props.bestellung.anzahlLieferstellen > 1 && Object.entries(props.bestellung.lieferstellen).map(([key, value], index) => { 
					return <Lieferstelle
						key={index+2}
						number={index+2}
						plz={value.plz}
						liefermenge={value.liefermenge}
						contact={{
							company: contact[key].company,
							first: contact[key].first,
							last: contact[key].last,
							street: contact[key].street,
							street_number: contact[key].street_number,
							city: contact[key].city,
							email: contact[key].email,
							billing: contact[key].billing,
							birthday: contact[key].birthday,
							payment: {
								method: contact[key].payment.method,
								price: contact[key].payment.price
							}
						}}
					/>
				})}


			</div>
			{props.bestellung.settings.kwk ?
				<Radio
					className="no__kwkradio"
					type="checkbox"
					name="no__kwk"
					selected={kwk}
					handleChange={handleKwk}
					checked={kwk}
					options={[{label: 'Ich wurde geworben', value: true}]}
				
				></Radio>
				: null
			}
			{kwk ?
				<><Input
				className="no__kwkinput"
				type="text"
				label="Kundennummer des Werbenden"
				id="no__kwk-kundennummer"
				required={true}
				value={props.bestellung.contact.main.werberId}
				handleChange={handleKwkId}
				handleBlur={handleKwkIdBlur}
				changeEvent={true}
			/>
				{error && <div className='error' style={{ margin: '-20px 0 20px 0' }}><p>{error}</p></div>}</>
				: null
			}

				
			<div className="no__input-group no__textarea">
				<label htmlFor="no__info">Haben Sie noch Anmerkungen für uns?</label>
				<textarea name="info" id="no__info" cols="30" rows="5" onChange={handleTextareaChange} value={props.bestellung.comment}></textarea>
			</div>

			<div className="no__submitcheck">
				{props.bestellung.settings.gewinnspiel ?
					<label htmlFor="no__gewinnspiel_cb"><input type="checkbox" name="submit" id="no__gewinnspiel_cb" onChange={() => setGewinnspiel(!gewinnspiel)} /><p dangerouslySetInnerHTML={{ __html: props.bestellung.settings.gewinnspiel }}></p></label> :
					null
				}
				<label htmlFor="no__submit">
					<input type="checkbox" name="submit" id="no__submit" onChange={() => setConsent(!consent)} />
					<p>Ich habe die <a href="/agb" target="_blank">AGBs</a> gelesen und akzeptiere diese.</p>
				</label>
				<label htmlFor="no__submit2">
					<input type="checkbox" name="submit" id="no__submit2" onChange={() => setPrivacyConsent(!privacyConsent)} />
					<p>Ich habe die <a href="/datenschutz" target="_blank">Datenschutzbestimmungen</a> gelesen und akzeptiere diese.</p>
				</label>
				<a href="/widerruf" target="_blank">Kein Widerrufsrecht</a>
				<div className="no__nav-buttons">
					<div onClick={() => setStep(prev => prev - 1)} className="no__primary back__button" >Zurück</div>
					<Button
						click={handleSubmit}
						disabled={!consent || !privacyConsent || (props.bestellung.settings.gewinnspiel && !gewinnspiel) || isLoading || error}
						className="no__primary"
						title={isLoading ? "Daten werden gesendet ..." : "Zahlungspflichtig bestellen"}
					/>
				</div>
			</div>
			{isLoading && <Loader/>}
			{submissionError &&
				<Modal
					type="no__alert"
					handleClose={setSubmissionError}
				>
					<strong>Das Formular konnte nicht gesendet werden. Bitte überprüfen Sie alle Angaben oder versuchen Sie es später nocheinmal.</strong>
				</Modal>}
		</div>
	)
}

export default SubmitScreen
